/* eslint-disable */
import { IToast } from "@/interfaces/toast/IToast";
import { IState } from "@/interfaces/IState";
import Vue from "vue";
import Toasted from "vue-toasted";
import "../../assets/styles/toast.css";

Vue.use(Toasted);

export const toast = {
  state: {
    toast: [],
  },

  mutations: {
    DISPLAY_TOAST_SUCCESS(state: IState, payload: IToast) {
      const content =
        "<div class='toast-container'><h2>" +
        payload.title +
        "</h2><p>" +
        payload.message +
        "</p></div>";
      Vue.toasted.show(content, {
        type: "success",
        position: "top-center",
        icon: "check",
        iconPack: "mdi",
        duration: 3000,
      });
    },

    DISPLAY_TOAST_ERROR(state: IState, payload: IToast) {
      const content =
        "<div class='toast-container'><h2>" +
        payload.title +
        "</h2><p>" +
        payload.message +
        "</p></div>";
      Vue.toasted.show(content, {
        type: "error",
        position: "top-center",
        icon: "check",
        iconPack: "mdi",
        duration: 3000,
      });
    },

    DISPLAY_TOAST_INFO(state: IState, payload: IToast) {
      const content =
        "<div class='toast-container'><h2>" +
        payload.title +
        "</h2><p>" +
        payload.message +
        "</p></div>";
      Vue.toasted.show(content, {
        type: "info",
        position: "top-center",
        icon: "check",
        iconPack: "mdi",
        duration: 3000,
      });
    },

    DISPLAY_TOAST_WARNING(state: IState, payload: IToast) {
      const content =
        "<div class='toast-container'><h2>" +
        payload.title +
        "</h2><p>" +
        payload.message +
        "</p></div>";
      Vue.toasted.show(content, {
        type: "warning",
        position: "top-center",
        icon: "check",
        iconPack: "mdi",
        duration: 300000000,
      });
    },
  },

  actions: {
    toastSuccess(context: any, payload: IToast) {
      context.commit("DISPLAY_TOAST_SUCCESS", payload);
    },
    toastError(context: any, payload: IToast) {
      context.commit("DISPLAY_TOAST_ERROR", payload);
    },
    toastInfo(context: any, payload: IToast) {
      context.commit("DISPLAY_TOAST_INFO", payload);
    },
    toastWarning(context: any, payload: IToast) {
      context.commit("DISPLAY_TOAST_WARNING", payload);
    },
  },
};
